import styled from 'styled-components'

export const RelationsContainer = styled.div`
  padding: 16px 0;
  width: 100%;
`

export const RelationsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const RelationCard = styled.div<{ $clickable?: boolean }>`
  display: block;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grayLight};
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
  cursor: ${({ $clickable }) => $clickable ? 'pointer' : 'default'};
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme, $clickable }) => $clickable ? theme.colors.blue : theme.colors.grayLight};
    box-shadow: ${({ $clickable }) => $clickable ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none'};
  }
`

export const RelationHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayLight};
`

export const RelationTitle = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.fs16};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.4;
`
/*
export const RelationLink = styled.a`
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.blue};

    ${RelationTitle} {
      color: ${({ theme }) => theme.colors.blue};
    }
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.blue};
    outline-offset: 2px;
    border-radius: 4px;
  }
`

export const RelationStage = styled.span`
  display: inline-block;
  padding: 4px 8px;
  font-size: ${({ theme }) => theme.fontSizes.fs12};
  font-weight: 500;
  background: ${({ theme }) => theme.colors.blueSub};
  color: ${({ theme }) => theme.colors.blue};
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
`
*/
export const RelationInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`

export const RelationInfoRow = styled.div`
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`

export const RelationInfoCol = styled.div`
  display: flex;
  flex-direction: column;
`

export const RelationInfoLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.fs14};
  color: ${({ theme }) => theme.colors.graySubNormal};
  min-width: 120px;
  flex-shrink: 0;
  
  @media (max-width: 480px) {
    min-width: auto;
    font-size: ${({ theme }) => theme.fontSizes.fs12};
  }
`

export const RelationInfoValue = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.fs14};
  color: ${({ theme }) => theme.colors.black};
  word-break: break-word;
  line-height: 1.4;
  
  @media (max-width: 480px) {
    font-size: ${({ theme }) => theme.fontSizes.fs14};
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 16px;
  min-height: 200px;
`
